import { TargetingElementKeys } from '@openx/components-targeting/Targeting/TargetingPresets/context/types';
import type { TargetingWithUrlTargeting } from '@openx/types/package';
import { InventoryFormatTypeOption } from '@openx/types/targeting/formatType';
import { InventoryContentOption } from '@openx/types/targeting/inventoryAndContent';

export const isLocationIconActive = (targeting?: TargetingWithUrlTargeting): boolean => {
  if (!targeting) return false;

  const { content, url_targeting, domain } = targeting;
  return (
    !!content?.[InventoryContentOption.PAGE_URL]?.val ||
    !!content?.includes ||
    !!content?.excludes ||
    !!domain?.categories?.val ||
    !!domain?.categories_iab_v2?.val ||
    (!!url_targeting?.type && !!url_targeting?.urls)
  );
};

export const isUsersIconActive = (targeting?: TargetingWithUrlTargeting): boolean => {
  if (!targeting) return false;

  const { audience } = targeting;

  return !!audience?.liveintent || !!audience?.dmp_segments || !!audience?.openaudience_custom;
};

export const isCTVIconActive = (targeting?: TargetingWithUrlTargeting): boolean => {
  if (!targeting) return false;
  const { inventory_format, technographic, rendering_context } = targeting;

  const isNewCTV = !!rendering_context?.ad_placement?.val?.includes(TargetingElementKeys.FORMAT_CTV);
  const isOldCTV =
    (inventory_format?.[InventoryFormatTypeOption.AD_PLACEMENT]?.val?.includes('VIDEO') &&
      inventory_format?.[InventoryFormatTypeOption.DISTRIBUTION_CHANNEL]?.val?.includes('APP') &&
      technographic?.device_type?.val?.includes('5') &&
      technographic?.device_type?.val?.includes('6')) ??
    false;

  return isNewCTV || isOldCTV;
};

export const isDesktopIconActive = (targeting?: TargetingWithUrlTargeting): boolean => {
  if (!targeting) return false;

  const { inventory_format, technographic, rendering_context } = targeting;

  const isNewDesktop =
    !!rendering_context?.distribution_channel?.val?.includes(TargetingElementKeys.CHANNEL_WEB) ||
    !!rendering_context?.device_type?.desktop_devices;
  const isOldDesktop =
    (inventory_format?.[InventoryFormatTypeOption.DISTRIBUTION_CHANNEL]?.val?.includes('WEB') ||
      technographic?.device_type?.val?.includes('3')) ??
    false;

  return isNewDesktop || isOldDesktop;
};

export const isPhoneIconActive = (targeting?: TargetingWithUrlTargeting): boolean => {
  if (!targeting) return false;

  const { technographic, rendering_context } = targeting;

  const isNewMobile = !!rendering_context?.device_type?.mobile_devices;
  const isOldMobile =
    (technographic?.device_type?.val?.includes('1') || technographic?.device_type?.val?.includes('2')) ?? false;

  return isNewMobile || isOldMobile;
};

export const getIconColor = (condition: boolean): 'success' | 'disabled' => (condition ? 'success' : 'disabled');
